export const TAG = 'tags';
export const ENGLISH_TAGS = 'post_tag';
export const GERMAN_TAGS = 'german_tags';
export const FRENCH_TAGS = 'french_tags';
export const ITALIAN_TAGS = 'italian_tags';
export const POLISH_TAGS = 'polish_tags';
export const PORTUGUESE_TAGS = 'portuguese_tags';
export const SPANISH_TAGS = 'spanish_tags';
export const SWEDISH_TAGS = 'swedish_tags';

export const CATEGORY = 'categories';
export const ENGLISH_CATEGORIES = 'category';
export const GERMAN_CATEGORIES = 'german_categories';
export const FRENCH_CATEGORIES = 'french_categories';
export const ITALIAN_CATEGORIES = 'italian_categories';
export const POLISH_CATEGORIES = 'polish_categories';
export const PORTUGUESE_CATEGORIES = 'portuguese_categories';
export const SPANISH_CATEGORIES = 'spanish_categories';
export const SWEDISH_CATEGORIES = 'swedish_categories';

export default {
  TAG,
  ENGLISH_TAGS,
  GERMAN_TAGS,
  FRENCH_TAGS,
  ITALIAN_TAGS,
  POLISH_TAGS,
  PORTUGUESE_TAGS,
  SPANISH_TAGS,
  SWEDISH_TAGS,
  CATEGORY,
  ENGLISH_CATEGORIES,
  GERMAN_CATEGORIES,
  FRENCH_CATEGORIES,
  ITALIAN_CATEGORIES,
  POLISH_CATEGORIES,
  PORTUGUESE_CATEGORIES,
  SPANISH_CATEGORIES,
  SWEDISH_CATEGORIES,
};
